import { render } from "./offer-template-headers.vue?vue&type=template&id=198a9868&scoped=true"
import script from "./offer-template-headers.vue?vue&type=script&lang=js"
export * from "./offer-template-headers.vue?vue&type=script&lang=js"

import "./offer-template-headers.vue?vue&type=style&index=0&id=198a9868&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-198a9868"]])

export default __exports__